import React from 'react'
import './Product.css'
import { useStateValue } from "./StateProvider";


function Product({ id, title, image, price, rating }) {

    const [{ basket }, dispatch] = useStateValue();

    console.log("this is the basket >>> ", basket);

    const addToBasket = () => {
        // dispatch the item into the data layer (lets you shoot into the data layer)
        dispatch({
            type: "ADD_TO_BASKET",
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
                rating: rating,
            },
        });
    };



    return (
        <div className='product'>
            <div className="product_info">
                <p>{title}</p>
                <p className='product_price'>
                    <small>$</small>
                    <strong>{price}</strong>
                </p>
                <div className="product_rating">
                    {Array(rating).fill().map((_, i) => (<span>&#127775;</span>)) // For making a star appear for ratings
                    }

                </div>

            </div>

            <img src={image} alt=""
            />

            <button onClick={addToBasket}>Add to Basket</button> {/* Making add to basket button interactable */}

        </div>
    )
}

export default Product
